import "core-js/modules/es.array.push.js";
import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, Fragment, renderList, toDisplayString, createTextVNode, createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "sleeping-bag-size-chart"
};
const _hoisted_2 = {
  class: "sleeping-bag-size-chart__table-wrapper"
};
const _hoisted_3 = ["aria-describedby"];
const _hoisted_4 = ["colspan"];
const _hoisted_5 = ["rowspan"];
const _hoisted_6 = {
  scope: "row",
  class: "sleeping-bag-size-chart__table-row-header-data"
};
const _hoisted_7 = {
  key: 0,
  id: "size-notes",
  class: "sleeping-bag-size-chart__notes"
};
const _hoisted_8 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SleepingBagSizeChart",
  props: {
    tableData: {
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const ariaDescribedby = computed(() => {
      var _a;
      return ((_a = props.tableData) == null ? void 0 : _a.notes) ? "size-notes" : null;
    });
    const sizeMap = computed(() => {
      var _a, _b;
      const result = {};
      const heights2 = ((_a = props.tableData) == null ? void 0 : _a.rows[0].values) || [];
      const hips2 = ((_b = props.tableData) == null ? void 0 : _b.rows[1].values) || [];
      const {
        sizes
      } = props.tableData || {};
      for (let i = 0; i < heights2.length; i++) {
        const key = heights2[i].label.trim();
        const subKey = hips2 == null ? void 0 : hips2[i].label.trim();
        const value = sizes == null ? void 0 : sizes[i].label.trim();
        if (result[key] && value) {
          result[key][subKey] = value;
        } else if (subKey && value) {
          result[key] = {
            [subKey]: value
          };
        }
      }
      return result;
    });
    const heights = computed(() => {
      const heightsList = [];
      if (props.tableData) {
        for (const height of props.tableData.rows[0].values) {
          if (!heightsList.includes(height.label.trim())) {
            heightsList.push(height.label.trim());
          }
        }
      }
      return heightsList;
    });
    const hips = computed(() => {
      const hipsList = [];
      if (props.tableData) {
        for (const hip of props.tableData.rows[1].values) {
          if (!hipsList.includes(hip.label.trim())) {
            hipsList.push(hip.label.trim());
          }
        }
      }
      return hipsList;
    });
    return (_ctx, _cache) => {
      return _ctx.tableData ? (openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("table", {
        tabindex: "0",
        "aria-label": "sleeping-bag-size-chart",
        "aria-describedby": ariaDescribedby.value
      }, [createElementVNode("thead", null, [createElementVNode("tr", null, [_cache[1] || (_cache[1] = createElementVNode("th", {
        "aria-hidden": "true",
        class: "sleeping-bag-size-chart__table-row-header-label"
      }, null, -1)), _cache[2] || (_cache[2] = createElementVNode("th", {
        "aria-hidden": "true",
        class: "sleeping-bag-size-chart__table-row-header-data"
      }, null, -1)), createElementVNode("th", {
        colspan: hips.value.length + 1,
        scope: "col"
      }, _cache[0] || (_cache[0] = [createElementVNode("p", null, "Hip Girth", -1), createElementVNode("p", null, "The circumference at the widest point of your hips.", -1)]), 8, _hoisted_4)]), createElementVNode("tr", null, [_cache[3] || (_cache[3] = createElementVNode("th", {
        "aria-hidden": "true",
        class: "sleeping-bag-size-chart__table-row-header-label"
      }, null, -1)), _cache[4] || (_cache[4] = createElementVNode("th", {
        "aria-hidden": "true",
        class: "sleeping-bag-size-chart__table-row-header-data sleeping-bag-size-chart__table-row-header-data--last"
      }, null, -1)), (openBlock(true), createElementBlock(Fragment, null, renderList(hips.value, (hip) => {
        return openBlock(), createElementBlock("th", {
          key: hip,
          scope: "col",
          class: "sleeping-bag-size-chart__table-col-header-data"
        }, toDisplayString(hip), 1);
      }), 128))])]), createElementVNode("tbody", null, [createElementVNode("tr", null, [createElementVNode("th", {
        rowspan: heights.value.length + 1,
        scope: "row",
        class: "sleeping-bag-size-chart__table-row-header--vertical sleeping-bag-size-chart__table-row-header-label"
      }, _cache[5] || (_cache[5] = [createElementVNode("span", null, "Height", -1)]), 8, _hoisted_5)]), (openBlock(true), createElementBlock(Fragment, null, renderList(heights.value, (height, i) => {
        return openBlock(), createElementBlock("tr", {
          key: height
        }, [createElementVNode("th", _hoisted_6, toDisplayString(height), 1), (openBlock(true), createElementBlock(Fragment, null, renderList(hips.value, (hip, j) => {
          return openBlock(), createElementBlock("td", {
            key: hip
          }, [sizeMap.value[heights.value[i]][hips.value[j]] ? (openBlock(), createElementBlock(Fragment, {
            key: 0
          }, [createTextVNode(toDisplayString(sizeMap.value[heights.value[i]][hips.value[j]]), 1)], 64)) : (openBlock(), createElementBlock(Fragment, {
            key: 1
          }, [_cache[6] || (_cache[6] = createElementVNode("span", {
            class: "pdp-sr-only"
          }, "no size found", -1)), _cache[7] || (_cache[7] = createElementVNode("img", {
            "aria-hidden": "true",
            alt: "no size found",
            src: "https://satchel.rei.com/media/product/sleeping-bag-chart-arrows.svg"
          }, null, -1))], 64))]);
        }), 128))]);
      }), 128))])], 8, _hoisted_3)]), _ctx.tableData.notes ? (openBlock(), createElementBlock("div", _hoisted_7, [_cache[8] || (_cache[8] = createElementVNode("h2", {
        class: "sleeping-bag-size-chart__notes__heading"
      }, " Sizing Notes ", -1)), createElementVNode("p", {
        class: "sleeping-bag-size-chart__notes__details",
        innerHTML: _ctx.tableData.notes
      }, null, 8, _hoisted_8)])) : createCommentVNode("", true)])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SleepingBagSizeChart2.mjs.map
